<section class="py-16 bg-dark-light">
  <div class="container mx-auto px-4">
    <div class="max-w-4xl mx-auto">
      <h2 class="text-3xl md:text-4xl font-bold mb-8 text-center text-light">
        Waarom Kies Voor Kansino Nederland?
      </h2>
      
      <div class="prose max-w-none text-gray-300 prose-invert">
        <p class="text-lg mb-6">
          Bij Kansino Nederland helpen we u de beste online casino ervaring te vinden. 
          Ons team van experts test en evalueert regelmatig verschillende platforms op basis van:
        </p>

        <div class="grid md:grid-cols-2 gap-6 mt-8">
          <div class="bg-dark p-6 rounded-lg border border-light/10 hover:border-primary transition-all duration-300">
            <h3 class="text-xl font-semibold mb-3 text-accent">✓ Veiligheid & Licenties</h3>
            <p class="text-gray-300">
              We beoordelen alleen platforms met geldige licenties en bewezen resultaten 
              voor veiligheid en betrouwbaarheid.
            </p>
          </div>

          <div class="bg-dark p-6 rounded-lg border border-light/10 hover:border-primary transition-all duration-300">
            <h3 class="text-xl font-semibold mb-3 text-accent">✓ Beste Bonussen</h3>
            <p class="text-gray-300">
              Ontdek exclusieve welkomstbonussen, gratis spins en speciale aanbiedingen 
              die alleen beschikbaar zijn via onze links.
            </p>
          </div>

          <div class="bg-dark p-6 rounded-lg border border-light/10 hover:border-primary transition-all duration-300">
            <h3 class="text-xl font-semibold mb-3 text-accent">✓ Gebruikerservaring</h3>
            <p class="text-gray-300">
              We testen de gebruiksvriendelijkheid, laadsnelheid en mobiele compatibiliteit 
              van elk platform.
            </p>
          </div>

          <div class="bg-dark p-6 rounded-lg border border-light/10 hover:border-primary transition-all duration-300">
            <h3 class="text-xl font-semibold mb-3 text-accent">✓ Klantenservice</h3>
            <p class="text-gray-300">
              We evalueren de kwaliteit en beschikbaarheid van klantenservice om ervoor 
              te zorgen dat u altijd hulp kunt krijgen.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

